import React from 'react'

interface StandaloneCheckboxProps {
  id: string
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
}

const StandaloneCheckbox: React.FC<StandaloneCheckboxProps> = ({
  id,
  label,
  checked,
  onChange,
}) => {
  return (
    <div className="relative flex items-start">
      <div className="flex h-6 items-center">
        <input
          id={id}
          aria-describedby={`${id}-description`}
          name={id}
          type="checkbox"
          className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-600"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
        />
      </div>
      {label && (
        <div className="ml-3 text-sm leading-6 font-normal">
          <label htmlFor={id} className="text-gray-500">
            {label}
          </label>{' '}
        </div>
      )}
    </div>
  )
}

export default StandaloneCheckbox
